/**
 * Mintegral 一个广告链接对应多本书,书章信息约定塞在 utm_adset 里,两种有效形式:
 * - {bookId}_{chapterId}:跳章节阅读页(chapterId 非空)
 * - {bookId}_:下划线后为空,跳书详情页(chapterId 为 null)
 * 其它情况(无下划线、书 id 段为空、超过 2 段)视为普通 adset 名,不处理
 */
export function parseMintegralAdsetTarget(utmAdset: string): { bookId: string; chapterId: string | null } | null {
  if (!utmAdset || !utmAdset.includes('_'))
    return null
  const parts = utmAdset.split('_')
  if (parts.length !== 2)
    return null
  const [bookId, chapterId] = parts
  if (!bookId)
    return null
  return { bookId, chapterId: chapterId || null }
}
